const SERVICE_WORKER_URL = '/service-worker.js';
let controllerListenerAttached = false;

function emit(eventName, detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(eventName, { detail }));
}

function emitUpdateIfWaiting(registration) {
  if (registration?.waiting) {
    emit('decoder-sw-update', { registration });
  }
}

export function requestServiceWorkerUpdate(registration) {
  if (!registration?.waiting) return false;
  registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  return true;
}

export function register() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(SERVICE_WORKER_URL)
      .then(registration => {
        emitUpdateIfWaiting(registration);

        registration.addEventListener('updatefound', () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;

          installingWorker.addEventListener('statechange', () => {
            if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
              emitUpdateIfWaiting(registration);
            }
          });
        });

        if (!controllerListenerAttached) {
          controllerListenerAttached = true;
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            emit('decoder-sw-controllerchange');
          });
        }
      })
      .catch(err => {
        console.error('Service worker registration failed:', err);
      });
  });
}
